import React, { useContext } from 'react';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import { DataContext } from '../../contexts/DataContext';
import { WelcomeCardHeader } from '../WelcomeCardHeader/WelcomeCardHeader';
import { NotificationSection } from '../NotificationSection';
import { WelcomeCardErrorPage } from '../WelcomeCardErrorPage/WelcomeCardErrorPage';

const exportsForTesting = {};

const TabletWelcomeCard = (props) => {
  const { isLoading, tiles, userDataError } = useContext(DataContext);
  const { handleOnClick } = props;

  const Card = () => {
    return (
      <Col className="loyalty_benefits__welcomeCard">
        <div className="loyalty_benefits__headerSection">
          <Row className="loyalty_benefits__tabletHeader">
            <WelcomeCardHeader />
            <div className="loyalty_benefits__tabletMoreLink">
              <div className="loyalty_benefits__tabletBenefitsLabel">
                More Great Pro Xtra Benefits
                <span className="loyalty_benefits__tabletArrow" />
              </div>
            </div>
          </Row>
        </div>
        <div className="loyalty_benefits__tabletNotification">
          <NotificationSection tiles={tiles.NOTIFICATION} />
        </div>
      </Col>
    );
  };

  const RenderTabletWelcomeCard = () => {
    return (
      <Row xs="12" sm="12" md="12" lg="12">
        {(!isLoading && !userDataError) ? <Card /> : (
          <WelcomeCardErrorPage
            handleOnClick={handleOnClick}
            cardLoaded={!isLoading}
          />
        )}
      </Row>
    );
  };

  exportsForTesting.handleOnClick = handleOnClick;
  exportsForTesting.Card = Card;
  exportsForTesting.RenderTabletWelcomeCard = RenderTabletWelcomeCard;

  return <RenderTabletWelcomeCard />;
};

export { TabletWelcomeCard, exportsForTesting };
